var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',_vm._b({staticClass:"Icon",attrs:{"name":_vm.name}},'v-icon',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }